(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var initializedAttribute = 'data-jw-motion-initialized';

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function revealImmediately(element) {
    if (element) element.classList.add('jw-is-visible');
  }

  var observer = null;

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          revealImmediately(entry.target);
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -5% 0px'
      }
    );
  }

  function observe(element, type, delay) {
    if (!element || element.hasAttribute(initializedAttribute)) return;

    element.setAttribute(initializedAttribute, 'true');
    element.setAttribute('data-jw-reveal', type || 'section');
    element.style.setProperty('--jw-reveal-delay', String(delay || 0) + 'ms');

    if (reduceMotion.matches || !observer) {
      revealImmediately(element);
      return;
    }

    observer.observe(element);
  }

  function topLevelCards(section) {
    var candidates = toArray(
      section.querySelectorAll(
        'product-card, collection-card, .product-card, .product-grid__card, .resource-card, .testimonial-grid__card, [class*="product-card"], [class*="collection-card"]'
      )
    );

    return candidates.filter(function (candidate) {
      return !candidates.some(function (other) {
        return other !== candidate && other.contains(candidate);
      });
    });
  }

  function initializeSection(section, index) {
    if (!section || section.closest('#header-group, #footer-group, header, footer')) return;

    if (index === 0) {
      observe(section.querySelector('.overlap-hero__media-layer--desktop, .overlap-hero__media-layer'), 'hero-media', 0);
      var heroContent = section.querySelector('.overlap-hero__content');
      if (heroContent) heroContent.classList.add('jw-hero-load');
      return;
    }

    var cards = topLevelCards(section);

    if (cards.length > 1) {
      cards.slice(0, 12).forEach(function (card, cardIndex) {
        observe(card, 'card', Math.min(cardIndex * 90, 540));
      });

      observe(section.querySelector('h2, h3'), 'section', 0);
      var intro = section.querySelector('.section-content-wrapper p, .testimonial-grid__subheading');
      if (intro && !intro.closest('product-card, collection-card, .product-grid__card, .testimonial-grid__card')) {
        observe(intro, 'section', 120);
      }
      return;
    }

    var contentWrapper = section.querySelector('.section-content-wrapper, [data-testid="section-content"]');
    var visibleChildren = contentWrapper
      ? toArray(contentWrapper.children).filter(function (child) {
          return !child.matches('.overlay, script, style, link') && !child.hidden;
        })
      : [];

    if (visibleChildren.length) {
      visibleChildren.slice(0, 8).forEach(function (child, childIndex) {
        observe(child, 'section', Math.min(childIndex * 140, 420));
      });
      return;
    }

    var content = toArray(section.children).filter(function (child) {
      return !child.matches('.section-background, script, style, link') && !child.hidden;
    })[0];

    observe(content || section, 'section', 0);
  }

  function getContentSections() {
    var contentRoot = document.querySelector('#MainContent, main, [role="main"]') || document.body;

    return toArray(contentRoot.querySelectorAll('.shopify-section')).filter(function (section) {
      return !section.closest('#header-group, #footer-group, header, footer');
    });
  }

  function initialize() {
    var sections = getContentSections();
    if (!sections.length) return;

    sections.forEach(initializeSection);
    root.classList.add('jw-motion-ready');
    root.setAttribute('data-jw-motion-section-count', String(sections.length));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    var sections = getContentSections();
    var index = sections.indexOf(event.target);
    initializeSection(event.target, Math.max(index, 0));
  });

  function revealAllForReducedMotion(event) {
    if (!event.matches) return;
    toArray(document.querySelectorAll('[data-jw-reveal]')).forEach(revealImmediately);
  }

  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', revealAllForReducedMotion);
  } else if (reduceMotion.addListener) {
    reduceMotion.addListener(revealAllForReducedMotion);
  }
})();
